import { Ddbox } from "./ddbox";
import { Swimmer } from "./swimmer";
import { MarketingClientShareArticleOld } from "./marketing-client-share-article-old";
import { MarketingClientShareArticle } from "./marketing-client-share-article";
import { Hat } from "./marketing-client-hat";
import { MarketingClientRWFirstPromotion } from "./marketing-client-rw-first-promotion";
import { MarketingClientRWSecondPromotion } from "./marketing-client-rw-second-promotion";
import { Capping } from "./marketing-client-capping";
import { Utilization } from "./marketing-client-utilization";
import { MarketingClientRWOwner } from "./marketing-client-rw-owner";
import { OneDayPass } from "./marketing-client-one-day-pass";
import { OneDayPassOld } from "./marketing-client-one-day-pass-old";
import { DOMHelper } from "./helpers/dom-helper";
import { RwSelector } from "./constants/rw-object.constants";
import { SwfSelector } from "./constants/swf-constants";
import RecommendationsCop from "./utils/recommendations-cop/recommendations-cop";
import { Theme } from "./marketing-client-theme";
import { Selector } from "./constants/one-day-pass-old-constants";
import { ClosingWithoutLp } from "./marketing-client-closing-without-lp";
import { AdsRewarded } from "./utils/ads-rewarded";
import { HardClosing } from "./marketing-client-hard-closing";
import { NewsletterSaver } from "./marketing-client-newsletter-saver";
import { Padlock } from "./marketing-client-padlock";

export class MarketingClientBanners {
    colotTheme: Theme;
    ddbox: Ddbox;
    swimmer: Swimmer;
    hat: Hat;
    marketingClientShareArticleOld: MarketingClientShareArticleOld;
    marketingClientShareArticle: MarketingClientShareArticle;
    marketingClientRWOwner: MarketingClientRWOwner;
    marketingClientRWFirstPromotion: MarketingClientRWFirstPromotion;
    marketingClientRWSecondPromotion: MarketingClientRWSecondPromotion;
    newsletterSaver: NewsletterSaver;
    oneDayPass: OneDayPass;
    oneDayPassOld: OneDayPassOld;
    recommendationsCop: RecommendationsCop;
    closingWithoutLp: ClosingWithoutLp;
    hardClosing: HardClosing;
    adsRewarded: AdsRewarded;
    padlock: Padlock;

    constructor(capping: Capping, utilization: Utilization, isMobile: boolean) {
        this.colotTheme = new Theme();
        this.ddbox = new Ddbox(isMobile, capping);
        this.hat = new Hat(isMobile);
        this.swimmer = new Swimmer(isMobile, capping);
        this.marketingClientShareArticleOld = new MarketingClientShareArticleOld(utilization);
        this.marketingClientShareArticle = new MarketingClientShareArticle(utilization);
        this.marketingClientRWFirstPromotion = new MarketingClientRWFirstPromotion(capping, utilization);
        this.marketingClientRWSecondPromotion = new MarketingClientRWSecondPromotion(capping, utilization);
        this.marketingClientRWOwner = new MarketingClientRWOwner(capping, utilization);
        this.oneDayPass = new OneDayPass(capping, utilization);
        this.oneDayPassOld = new OneDayPassOld(capping, utilization);
        this.recommendationsCop = new RecommendationsCop(isMobile);
        this.closingWithoutLp = new ClosingWithoutLp(isMobile);
        this.hardClosing = new HardClosing(isMobile);
        this.adsRewarded = new AdsRewarded();
        this.newsletterSaver = new NewsletterSaver(capping, utilization);
        this.padlock = new Padlock();
    }

    init() {
        this.colotTheme.init();
        this.ddbox.init();
        this.swimmer.init();
        this.recommendationsCop.init(this.ddbox.ddboxIsVisible);
        this.hat.init();
        this.closingWithoutLp.init();
        this.initSwf();
        this.initRw();
        this.initOneDayPass();
        this.initHardClosing();
        this.adsRewarded.init();
        this.newsletterSaver.init();
        this.padlock.init();
    }

    initRw() {
        const rwFirstPromotionDom: Element | null = DOMHelper.querySelector(RwSelector.rwFirstPromotionSelector),
            rwSecondPromotionDom: Element | null = DOMHelper.querySelector(RwSelector.rwSecondPromotionSelector);

        if (rwFirstPromotionDom) {
            this.marketingClientRWFirstPromotion.init();
        } else if (rwSecondPromotionDom) {
            this.marketingClientRWSecondPromotion.init();
        } else {
            this.marketingClientRWOwner.init();
        }
    }

    initSwf() {
        const swfOld = DOMHelper.querySelector(SwfSelector.oldSwfSelector) as HTMLElement;

        if (swfOld) {
            this.marketingClientShareArticleOld.init();
        } else {
            this.marketingClientShareArticle.init();
        }
    }

    initOneDayPass() {
        const oneDayPassOld = DOMHelper.querySelector(Selector.closeActivation) as HTMLElement;

        if (oneDayPassOld) {
            this.oneDayPassOld.init();
        } else {
            this.oneDayPass.init();
        }
    }

    initHardClosing() {
        const section = DOMHelper.querySelector(".nw_2023_hard_closing") as HTMLElement;
        section?.classList.add("hidden");

        this.hardClosing.init();
    }
}
